module.exports = __webpack_public_path__ + "img/logo.3dd0d9a8.png";